var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:telegram",
    clipPath: "url(#clip0_400_7354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C5.87875 0 3.8425 0.843375 2.34375 2.34313C0.843465 3.84348 0.000429311 5.87823 0 8C0 10.1209 0.84375 12.1571 2.34375 13.6569C3.8425 15.1566 5.87875 16 8 16C10.1213 16 12.1575 15.1566 13.6562 13.6569C15.1562 12.1571 16 10.1209 16 8C16 5.87913 15.1562 3.84288 13.6562 2.34313C12.1575 0.843375 10.1213 0 8 0Z",
    fill: "url(#paint0_linear_400_7354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.62107 7.9155C5.95357 6.8995 7.50857 6.22967 8.28607 5.906C10.5086 4.98188 10.9698 4.82138 11.2711 4.81594C11.3373 4.81488 11.4848 4.83125 11.5811 4.90906C11.6611 4.97469 11.6836 5.06344 11.6948 5.12575C11.7048 5.188 11.7186 5.32988 11.7073 5.44063C11.5873 6.70563 11.0661 9.77538 10.8011 11.1923C10.6898 11.7918 10.4686 11.9927 10.2548 12.0124C9.78982 12.0551 9.43732 11.7054 8.98732 11.4105C8.28357 10.9489 7.88607 10.6616 7.20232 10.2113C6.41232 9.69075 6.92482 9.40463 7.37482 8.93713C7.49232 8.81475 9.53982 6.95288 9.57857 6.784C9.58357 6.76288 9.58857 6.68412 9.54107 6.64262C9.49482 6.601 9.42607 6.61525 9.37607 6.6265C9.30482 6.6425 8.18107 7.386 6.00107 8.85688C5.68232 9.07613 5.39357 9.183 5.13357 9.17737C4.84857 9.17125 4.29857 9.01588 3.88982 8.88313C3.38982 8.72025 2.99107 8.63413 3.02607 8.3575C3.04357 8.2135 3.24232 8.06613 3.62107 7.9155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_7354",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 1600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_7354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bba2839c7752646b1f9430ccd607842c.svg";
export { ForwardRef as ReactComponent };